module.exports = __webpack_public_path__ + "static/media/mila.a81cf979.JPG";